import { render, staticRenderFns } from "./Pedidos_Resumen.vue?vue&type=template&id=51e1c876&scoped=true&"
import script from "./Pedidos_Resumen.vue?vue&type=script&lang=js&"
export * from "./Pedidos_Resumen.vue?vue&type=script&lang=js&"
import style0 from "./Pedidos_Resumen.vue?vue&type=style&index=0&id=51e1c876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e1c876",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
